import { Icon } from "@/components/Icons/Icon";
import { useAuthStore } from "@/store/auth.store";
import { useNavigate } from "react-router-dom";

interface WithdrawalSuccessPageProps {
  id: string;
  amount: number;
}

export const WithdrawalSuccessPage: React.FC<WithdrawalSuccessPageProps> = (props) => {
  const navigate = useNavigate();
  const fetchUser = useAuthStore((state) => state.fetchAndSetUser);
  const { id: orderId, amount } = props;

  if (!orderId) {
    throw new Error("OrderId must be registered");
  }

  const handleButton = () => {
    fetchUser();
    navigate("/record");
  };

  return (
    <div className="bg-white min-w-full min-h-screen">
      <div className="py-10 px-5 flex flex-col items-start gap-[30px] w-full">
        <div className="flex flex-col items-center gap-3 w-full">
          <Icon src="/assets/check.svg" imageSize={{ width: "96", height: "96" }} />
          <p className="text-lg font-bold text-black">出金処理中です</p>
          <p className="text-[10px] font-normal text-gray">2〜3営業日で着金となります</p>
        </div>
        <div className="flex flex-col items-start w-full gap-10">
          <div className="flex flex-col items-start gap-1 w-full">
            <p className="text-base text-black font-bold -tracking-[.01em]">出金額</p>
            <p className="text-base font-normal -tracking-[.01em] text-black pb-1 border-b border-[#ECECEC] border-solid w-full">
              {amount.toLocaleString()}円
            </p>
          </div>
        </div>
        <div className="flex flex-col items-start w-full gap-10">
          <div className="flex flex-col items-start gap-1 w-full">
            <p className="text-base text-black font-bold -tracking-[.01em]">注文ID</p>
            <p className="text-base font-normal -tracking-[.01em] text-black pb-1 border-b border-[#ECECEC] border-solid w-full">
              {orderId}
            </p>
          </div>
        </div>

        <button
          className="flex items-center justify-center bg-primary text-white py-2.5 px-4 text-lg font-bold w-full rounded-md"
          type="button"
          onClick={handleButton}
        >
          出金画面のTOPへ
        </button>
      </div>
    </div>
  );
};
